export function getUserType(user) {
    var _a, _b;
    return (_b = (_a = user === null || user === void 0 ? void 0 : user.metadata) === null || _a === void 0 ? void 0 : _a.userType) !== null && _b !== void 0 ? _b : 'user';
}
export function shouldHighlightUserType(type) {
    return type && type !== 'user';
}
//# sourceMappingURL=userTypes.js.map